import { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { Dropdown, Button, Form, Col, Row, Nav, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchUcrtList } from "../../../store/actions/ucrtsAction";
import TableDesign from "../../common/table/TableDesign";
import editIcon from '../../../assets/images/mega_edit.png';

import { resetPopup } from "../../../store/reducerSlice/ucrts";

import moment from "moment";
import ManageUcrt from "./ManageUcrt";
import Loader from "../../common/loader/Loader";
const tableHeadings = [
  // {
  //   label: "S. No.",
  // },
  {
    label: "Action",
  },
  {
    label: "Last Updated At",
  },
  {
    label: "Organisation",
  },
  {
    label: "UCRT MSE",
  },

  {
    label: "Staffing Status (Planned WTE)",
    whiteSpace: "text-wrap",
  },

  {
    label: "Service in BCP",
    whiteSpace: "text-wrap",
  },

  {
    label: "Patients on UCRT caseload (48 hours) ",
    whiteSpace: "text-wrap",
  },
  {
    label: "UCRT Patients identified for Virtual Ward",
    whiteSpace: "text-wrap",
  },
  {
    label: "Referrals to UCRT at 09:30",
    whiteSpace: "text-wrap",
  },
  {
    label: "Referrals at 12:30",
    whiteSpace: "text-wrap",
  },
  {
    label: "Referrals at 16:30",
    whiteSpace: "text-wrap",
  },
  {
    label: "Patients due for discharge",
    whiteSpace: "text-wrap",
  },
  {
    label: "Number of Care Packages (waiting for/coming in)",
    whiteSpace: "text-wrap",
  },
  {
    label: "Any changes",
  },
  {
    label: "Action taken",
  },
];


const UcrtList = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [modalShow, setModalShow] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [selectUcrt, setSelectUcrt] = useState(null);
  const [ucrtList, setUcrtList] = useState();
  const [message, setMessage] = useState(null);
  const [title, setTitle] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [searchText, setSearchText] = useState();
  const [activeTab, setActiveTab] = useState("");
  const searchInputRef = useRef(null);

  const [deleteRec, setDeleteRec] = useState(null);

  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [workForceLinkModalShow, setWorkForceLinkModalShow] = useState(false);
  const [toggleActivateRec, setToggleActivateRec] = useState(null);

  const [toggleActivateModalShow, setToggleActivateModalShow] = useState(false);
  const [modalUcrtShow, setModalUcrtShow] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [startDate, setStartDate] = useState(
    moment().subtract(30, "d").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [filterOption, setFilterOption] = useState({
    startDate: startDate,
    endDate: endDate,
    page: 1,
    // search: "",
    orderBy: "createdAt",
    orderIn: -1,
  });
  const {
    ucrts,
    filtered,
    pagination,
    isLoader,
    isRecordUpdated,
    isRecordAdded,
    error: apiError,
  } = useSelector((state) => {
    return state.ucrts;
  });
  useEffect(() => {
    console.log("startDate", startDate);
    console.log("endDate", endDate);
    dispatch(
      fetchUcrtList({
        startDate: startDate,
        endDate: endDate,
      })
    ).then(({ payload }) => {
      console.log("payload", payload);
      if (payload.success) {
        setUcrtList(payload?.data?.ucrts);
        hideHandlerRes();
      } else {
        setIsShow(true);
      }
    });
  }, [startDate, endDate]);

  const hideHandlerRes = () => {
    setIsShow(false);
  };

  const page = pagination?.currentPage;

  const cc = filtered || ucrts;

  // useEffect(() => {
  //   if (location?.state?.previousActiveTab) {
  //     setActiveTab(location?.state?.previousActiveTab);
  //     navigate(location.pathname, { replace: true });
  //   }
  // }, [location?.state?.previousActiveTab]);

  useEffect(() => {
    if (searchText || searchText === "") {
      filterHandler({
        startDate: startDate,
        endDate: endDate,
        search: searchText,
        page: 1,
      });
    }
  }, [searchText]);
  window.history.replaceState({}, document.title);

  useEffect(() => {
    if (!location?.state?.previousActiveTab) {
      console.log("startDate", startDate);
      console.log("endDate", endDate);
      const updatedFilterOption = {
        ...filterOption,
        startDate,
        endDate,
      };
      dispatch(fetchUcrtList(updatedFilterOption));
    }
  }, [filterOption, isRecordUpdated]);
  useEffect(() => {
    console.log("cc", cc);
    console.log("ucrtList", ucrtList);
  }, [cc, ucrtList]);
  const filterHandler = (obj) => {
    setFilterOption({
      ...filterOption,
      ...obj,
    });
  };

  const hideHandle = () => {
    setModalShow(false);
    setSelectUcrt(null);
    setDeleteModalShow(false);
    setDeleteRec(null);
    setToggleActivateModalShow(false);
    setToggleActivateRec(null);
    setWorkForceLinkModalShow(false);
    setModalUcrtShow(false);
  };

  const formatedDate = (val) => {
    var options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour12: true,
    };
    return new Date(val).toLocaleDateString("nl-NL", options);
  };
  const formatedTime = (val) => {
    var options = { hour12: true, hour: "2-digit", minute: "2-digit" };
    return new Date(val).toLocaleTimeString("en-US", options);
  };

  //  Report Navigate
  const navigateReport = () => {
    navigate("/ucrt-reports");
  };

  //  Ucrt Navigate
  const navigateUcrtModule = () => {
    navigate("/ucrt-module");
  };
  const addNewUCRT = () => {
    dispatch(resetPopup());
    setModalUcrtShow(true);

    setTitle("Add UCRT");
    setMessage("UCRT has been added successfully.");
    setShowResult(true);
  };
  const createUpdateUcrt = (row) => {
    console.log("row", row);
    setModalUcrtShow(true);
    setSelectUcrt(row);
  };
  const [scrollTable, setScrollTable] = useState(false);
  const handleScrollButtonClick = () => {
    setScrollTable(!scrollTable);
  };
  return (
    <>
      {/* Modal Download Date wise report */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          {" "}
          <h4 align="center" style={{ textAlign: "center", flex: "auto" }}>
            Date Wise Report
          </h4>
        </Modal.Header>
        <Modal.Body className="px-5">
          <Form.Group className="mb-3">
            <Form.Label>Date of the Report</Form.Label>
            <Form.Control type="date" placeholder="select" autoFocus />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="d-flex flex-column justify-content-center">
          {/* <a
            className="downloadBtn rounded"
            href={downloadFileOfDate}
            target="_blank"
          >
            <img src={download} /> Download Report
          </a> */}
          <span className="cancel-btn mt-4" onClick={handleClose}>
            Cancel
          </span>
        </Modal.Footer>
      </Modal>
      {/* End Model */}
      {/* End Model */}
      <div className="container">
        <ManageUcrt
          show={modalUcrtShow}
          onHide={hideHandle}
          title={
            selectUcrt
              ? `UCRT (${moment().format("LL")})`
              : `UCRT (${moment().format("LL")})`
          }
          selectUcrt={selectUcrt}
          setModalUcrtShow={setModalUcrtShow}
        />

        <h1 className="main-title">UCRT</h1>

        <div className="block-section">
          <Button
            variant="outline-primary btn-primary me-4 reportBtn"
            onClick={navigateUcrtModule}
          >
            UCRT 
          </Button>
          <Button
            variant="outline-primary"
            className="outline-primary me-4 reportBtn"
            onClick={navigateReport}
          >
            Daily UCRT Reports
          </Button>
        </div>
        {/* <div className="date-group" style={{ float: "right",paddingLeft:"16px" }}>
          <Form.Group style={{ marginRight: "10px", }}>
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              type="date"
              timeFormat="YYYY-MM-DD"
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              placeholder="Select"
              autoFocus
              name="start_date"
              max={new Date().toISOString().slice(0, 10)}
              defaultValue={startDate}
              onChange={(e) => {
                console.log("setDatefield-719", e.target.value);

                setStartDate(e.target.value);
              }}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>End Date</Form.Label>
            <Form.Control
              type="date"
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              placeholder="Select"
              autoFocus
              name="end_date"
              min={startDate}
              max={moment().format("YYYY-MM-DD")}
              defaultValue={endDate}
              onChange={(e) => {
                console.log("setDatefield-719", e.target.value);

                setEndDate(e.target.value);
              }}
            />
          </Form.Group>
        </div> */}
        <div
          className="para-range1"
          style={{ display: "flex", marginTop: "10px" }}
        >
          Workforce Capacity:
          <div className="ms-3" style={{ overflowX: "auto" }}>
            <Table striped bordered hover>
              <tbody style={{ textAlign: "center" }}>
                <tr>
                  <td style={{ padding: "2px 16px" }}>Below 40%</td>
                  <td style={{ padding: "2px 16px" }}>40% to 65%</td>
                  <td style={{ padding: "2px 16px" }}>65% to 80%</td>
                  <td style={{ padding: "2px 16px" }}>80% and above</td>
                </tr>
                <tr>
                  <td style={{ padding: "2px 16px" }}>4</td>
                  <td style={{ padding: "2px 16px" }}>3</td>
                  <td style={{ padding: "2px 16px" }}>2</td>
                  <td style={{ padding: "2px 16px" }}>1</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
        {/* <div
          style={{ display: "flex", justifyContent: "flex-end" }}
          className="ms-4 mb-2"
        >
          <Button
            variant="outline-primary btn-primary reportBtn"
            onClick={() => addNewUCRT()}
          >
            Add UCRT 
          </Button>
        </div> */}

        <TableDesign
          className="mt-5 pt-4"
          {...{
            title: "List of UCRT ",
            filterSection:(
              <>
              {/* <div className="date-group" style={{ float: "right",paddingLeft:"16px" }}> */}
          <Form.Group style={{ marginRight: "10px", }}>
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              type="date"
              timeFormat="YYYY-MM-DD"
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              placeholder="Select"
              autoFocus
              name="start_date"
              max={new Date().toISOString().slice(0, 10)}
              defaultValue={startDate}
              onChange={(e) => {
                console.log("setDatefield-719", e.target.value);

                setStartDate(e.target.value);
              }}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>End Date</Form.Label>
            <Form.Control
              type="date"
              onKeyDown={(e) => {
                e.preventDefault();
              }}
              placeholder="Select"
              autoFocus
              name="end_date"
              min={startDate}
              max={moment().format("YYYY-MM-DD")}
              defaultValue={endDate}
              onChange={(e) => {
                console.log("setDatefield-719", e.target.value);

                setEndDate(e.target.value);
              }}
            />
          </Form.Group>
        {/* </div> */}
              </>
            ),
            tableHeadings,
            filterHandler,
            pagination,
            filterOption,
            setFilterOption,
            isLoader,
          }}
        >
          {isLoader && <Loader />}
          {cc && cc.length ? (
            cc.map((row, i) => {
              if (row) {
                const isSameDate =
                  moment(row.createdAt).format("YYYY-MM-DD") ===
                  moment().format("YYYY-MM-DD");
                const isSameDateTime =
                  moment(row.createdAt).isSame(moment(row.updatedAt))
  

                const previousRow = cc.find(
                  (prevRow) =>
                    prevRow.locationId === row.locationId &&
                    moment(prevRow.updatedAt).isBefore(row.updatedAt)
                );
                return (
                  <tr key={i} className="align-items-center">
                    {/* <td align="center">
                      {i + 1 + (page > 1 && (page - 1) * 10)}
                    </td> */}
                    <td align="center">
                      <>
                        {moment(row.createdAt).format("YYYY-MM-DD") ===
                        moment().format("YYYY-MM-DD") ? (
                          <>
                             {!isSameDateTime ? (
                                  <img
                                    src={editIcon}
                                    style={{height:'16px',width:'16px',cursor:'pointer'}}
                                    alt="edit"
                                    onClick={() => createUpdateUcrt(row)}
                                  />
                                ) : (
                                  <img
                                    src={editIcon}
                                    alt="edit"
                                    style={{height:'16px',width:'16px',cursor:'pointer'}}
                                    onClick={() =>
                                      createUpdateUcrt(
                                        previousRow ? previousRow : row
                                      )
                                    }
                                  />
                                )}
                              
                          </>
                        ) : (
                          <></>
                        )}
                      </>
                    </td>
                    <td align="center">
                      {formatedDate(row.updatedAt)},<br />
                      {formatedTime(row.updatedAt)}
                    </td>
                    <td align="center">{row?.organization}</td>
                    <td align="center">{row?.ucrtMse}</td>
                    <td align="center">{row?.staffingStatus}</td>
                    <td align="center">{row?.bcpService}</td>
                    <td align="left">
                      {row?.caseloadPatients}
                    </td>
                    <td style={{ width: "120px" }}>{row?.virtuWardPatients}</td>
                    <td style={{ width: "120px" }}>{row?.referrals930}</td>
                    <td style={{ width: "120px" }}>{row?.referrals1230}</td>
                    <td style={{ width: "120px" }}>{row?.referrals1630}</td>
                    <td style={{ width: "120px" }}>{row?.duePatients}</td>
                    <td style={{ width: "120px" }}>{row?.carePackages}</td>
                    <td style={{ width: "120px" }}>{row?.anyChanges}</td>
                    <td style={{ width: "200px", whiteSpace: "nowrap" }}>
                      Social Care Delays -{" "}
                      {row?.action?.social_care_delays
                        ? row?.action?.social_care_delays
                        : "NA"}{" "}
                      <br />
                      Staffing Capacity -{" "}
                      {row?.action?.staffing_capacity
                        ? row?.action?.staffing_capacity
                        : "NA"}{" "}
                      <br />
                      Virtual Ward Delays -{" "}
                      {row?.action?.virtual_ward_delays
                        ? row?.action?.virtual_ward_delays
                        : "NA"}{" "}
                      <br />
                      Escalations -{" "}
                      {row?.action?.Escalations
                        ? row?.action?.Escalations
                        : "NA"}{" "}
                      <br />
                      BCP - {row?.action?.BCP ? row?.action?.BCP : "NA"} <br />
                    </td>
                  </tr>
                );
              }
            })
          ) : (
            <tr>
              <td colSpan="8">No Result Found</td>
            </tr>
          )}
        </TableDesign>
      </div>
    </>
  );
};

export default UcrtList;
